import { Checkbox, HStack } from "@chakra-ui/react";
import { SelectOption } from "./utils";

export const VerboseSelectOptions = ({
  value,
  setValue,
  options,
  disabled = false,
  required = false,
  nullable = false,
  reversed = false,
  invalid = false,
}: {
  value: any;
  setValue: (newValue: any) => void;
  options: SelectOption;
  disabled?: boolean;
  required?: boolean;
  nullable?: boolean;
  reversed?: boolean;
  invalid?: boolean;
}) => {
  const sortedOptions = reversed ? options.toReversed() : options;

  return (
    <HStack flexWrap={"wrap"}>
      {sortedOptions.map((option) => (
        <Checkbox.Root
          cursor={disabled ? "auto" : "pointer"}
          key={option.value}
          disabled={disabled}
          colorPalette="primary"
          checked={option.value === value}
          onCheckedChange={({ checked }) => {
            if (!nullable) {
              setValue(option.value);
            } else {
              setValue(checked ? option.value : null);
            }
          }}
        >
          {reversed && (
            <Checkbox.Label fontSize={"xs"} fontWeight={"normal"}>
              {option.label}
            </Checkbox.Label>
          )}
          <Checkbox.HiddenInput />
          <Checkbox.Control />
          {!reversed && (
            <Checkbox.Label fontSize={"xs"} fontWeight={"normal"}>
              {option.label}
            </Checkbox.Label>
          )}
        </Checkbox.Root>
      ))}
    </HStack>
  );
};
